import Button from '../../../../components/v2/Button/Button';
import { Modal } from '../../../../components/v2/Modal/Modal';
import { Typography } from '../../../../components/v2/Typography/Typography';

const MissingVowsModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className='flex flex-col gap-12'>
        <div className='text-center flex flex-col gap-4'>
          <Typography type='display-100'>
            Partner's vows needed for analysis
          </Typography>

          <Typography type='body-400'>
            Both Partners’ vows must be written for the analyze feature to be able to compare them. If
            you haven’t already invited your partner make sure you do so.
          </Typography>
        </div>
        <div className='flex justify-center'>
          <Button onClick={onClose}>Close</Button>
        </div>
      </div>
    </Modal>
  );
};
export default MissingVowsModal;
